<template>
  <div class="column-area">
    <div class="wrapper_main">

      <div class="paper_title">
        <span class="title_font" v-if="indexSearchFrom == 0"><a @click="clickReturnHome">首页-></a></span>
        <span class="title_font">{{searchResult}}</span>
      </div>
      <div class="text_list">
        <!-- 列表区域  -->
        <el-row div class="search-title" v-for = "(item,index) in searchDataList" :key="item.id">
          <h2>
            <a @click="openResourceByPageNum(item)">
              <span>
                {{item.resourceName}}<span class="color_red"> > </span>{{item.detailName}}<span class="color_red"> > </span>第 {{item.accessorySortIndex+1}} 页
              </span>
            </a>
          </h2>
          <div v-for="oneItem in item.hiLightContent">
            <span class="search-html" v-html="oneItem"></span>
          </div>
        </el-row>
      </div>
      <div style="..."></div>
      <!--分页-->
      <div class="paging-set">
        <el-pagination class="pagiing-num"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryEntity.current"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="queryEntity.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryEntity.total">
        </el-pagination>
      </div>
    </div>
  </div>

</template>

<script>
  import Consts from "@/common/consts"
  import indexApi from "@/api/indexsearch"
  import {confirm,pageParamNames} from '@/utils/constants'

  export default {
    name: 'indexList',
    data() {
      return{
        tableLoading: false,
        searchResult: null,
        searchDataList:[],
        indexSearchFrom: 0,
        queryEntity:{
          keyword: null,
          current: 1,
          pages: null,
          sizes: 10,
          total: 0,
          orderBy: null,
          sortInc: false,
          categoryCode: null,
          resourceType: Consts.RESOURCE_TYPE_NEWPAGE_JOURNAL,
        },
      }
    },
    inject: ["provideData"],
    props: {
      dataList: {
        type: [Object],
      }
     },
    created() {
      this.initData()
    },
    mounted(){
      //console.log(this.dataList.title);
    },
    methods:{
      initData(){
        this.queryEntity.keyword= null;
        this.queryEntity.current= 1;
        this.queryEntity.pages= null;
        this.queryEntity.sizes= 10;
        this.queryEntity.total= 0;
        this.queryEntity.extInt = Consts.RESOURCE_TYPE_NEWPAGER,
        this.queryEntity.orderField= "accessorySortIndex";
        this.searchResult = "全文检索 [ 0 ] 条记录"
      },
      indexQueryDataByKeyWord(categoryCode,queryKeyword){
        this.queryEntity.keyword = queryKeyword;
        this.indexSearchFrom = 0;
        //this.queryEntity.categoryCode = categoryCode;
        //全文检索不加分类号
        this.queryEntity.categoryCode = null;
        indexApi.indexSearchByKey(this.queryEntity).then(res => {
          var recordCount = 0;
          if (res!=null && res.data!=null){
            this.searchDataList = res.data.data.list;
            this.tableLoading = false;
            recordCount = res.data.data.total;
            pageParamNames.forEach(name => this.$set(this.queryEntity, name, res.data.data[name]))
          }
          this.searchResult = "全文检索 关键字：["+this.queryEntity.keyword+"] 共 ["+ recordCount + "] 条记录";
        })
      },
      indexQueryDataByKeyWordAndResourcelGuid(resourceGuid,queryKeyword){
        this.queryEntity.keyword = queryKeyword;
        this.queryEntity.resourceGuid = resourceGuid;
        this.indexSearchFrom = 1;
        //this.queryEntity.categoryCode = categoryCode;
        //全文检索不加分类号
        this.queryEntity.categoryCode = null;
        indexApi.indexSearchByKey(this.queryEntity).then(res => {
          var recordCount = 0;
          if (res!=null && res.data!=null){
            this.searchDataList = res.data.data.list;
            this.tableLoading = false;
            recordCount = res.data.data.total;
            pageParamNames.forEach(name => this.$set(this.queryEntity, name, res.data.data[name]))
          }
          this.searchResult = "全文检索 关键字：["+this.queryEntity.keyword+"] 共 ["+ recordCount + "] 条记录";
        })
      },
      clickReturnHome(){
        this.$emit('clickReturnHome','')
      },
      //分页
      handleSizeChange(val) {
        this.queryEntity.sizes = val;
        this.indexQueryDataByKeyWord();
      },
      handleCurrentChange(val) {
        this.queryEntity.current = val;
        this.indexQueryDataByKeyWord();
      },
      openResourceByPageNum: function (oneAccessory) {
        this.queryEntity.sizes = 1;
        let paraObject = {
          resourceName: oneAccessory.resourceName,
          volumeName: oneAccessory.subName,
          volumeGuid: oneAccessory.detailGuid,
          volumeIndexSort:oneAccessory.accessorySortIndex
        }
        console.log(paraObject);
        const { href } = this.$router.resolve({
          name: "readpage",
          query: paraObject,
        });
        window.open(href, '_blank');
        this.tableLoading = false;
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import url('../../styles/common.css');
  @import url('../../styles/main.css');

</style>



// WEBPACK FOOTER //
// src/view/column/indexList.vue